import ProcessingFeeCard from '@/components/global-admin/pricing/ProcessingFeeCard';

export default function AdvisorFeesPage() {
  return (
    <div className="space-y-6" data-testid="advisor-fees-page">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Advisor fees</h2>
        <p className="text-muted-foreground">
          What we take from what an advisor bills. Scheduling a new rate leaves invoices already
          raised alone.
        </p>
      </div>

      <ProcessingFeeCard />
    </div>
  );
}
